module.exports = __webpack_public_path__ + "img/hotdog_clasico.3abff7bd.jpg";